import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface IDisableState {
  pageDisable: boolean;
}

const initialState: IDisableState = {
  pageDisable: false,
};

export const disableSlice = createSlice({
  name: "disable",
  initialState,
  reducers: {
    setPageDisable: (state, action: PayloadAction<{ value: boolean }>) => {
      state.pageDisable = action.payload.value;
    },
  },
});

export const { setPageDisable } = disableSlice.actions;

export const selectPageDisable = (state: RootState) =>
  state.disable.pageDisable;

export default disableSlice.reducer;
